import { Box, Tooltip, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useState } from "react";
import AddProjectModal from "../../components/AddProjectModal";
import { useSelector } from "react-redux";


const Projects = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);

    const projectData = useSelector(state => state.projectReducer);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const columns = [
        { field: "id", headerName: "ID", felx: 0.5 },
        { field: "fy", headerName: "Financial Year" },
        {
            field: "client_name",
            headerName: "Client",
            flex: 1.5,
            cellClassName: "name-column--cell",
        },
        {
            field: "cp_name",
            headerName: "CP name",
            flex: 1.5,
        },
        {
            field: "capex_opex",
            headerName: "CAPEX/OPEX",
            flex: 1,
        },
        {
            field: "bd_owner",
            headerName: "BD Owner",
            flex: 0.5,
        },
        {
            field: "credit_rating",
            headerName: "Credit Rating",
            flex: 1,
        },
        {
            field: "dc_capacity_mwp",
            headerName: "DC Capacity(mwp)",
            flex: 1,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            flex: 2,
            cellClassName: 'show-all-text',
            renderCell: (params) => {
                <Tooltip title={params.value}>
                    <div className="cell-value">{params.value}</div>
                </Tooltip>
            }
        },

    ];

    return (
        <Box m="20px">
            <Box
                width="100%"
                display="flex"
                flexDirection="row"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                <Header title="Project Information" subtitle="List all projects with details" />
                <Button
                    variant="contained"
                    size="large"
                    sx={{
                        backgroundColor: colors.greenAccent[600],
                        fontSize: "1rem",
                        fontWeight: "600",
                        '&:hover': {
                            backgroundColor: colors.blueAccent[500],
                        },
                    }}
                    onClick={handleOpen}
                >Add New Project</Button>

            </Box>
            <AddProjectModal open={open} onClose={handleClose} newProjectId={projectData.length + 1} />
            <Box
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .show-all-text": {
                        whiteSpace: "normal",
                        overflow: "visible",
                    },
                    "& .cell-value": {
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                    },
                }}
            >
                <DataGrid rows={projectData}
                    columns={columns}
                    components={{ Toolbar: GridToolbar }} />
            </Box>
        </Box>
    );
};

export default Projects;